export const PENDING = 'PENDING';
export const UNDELIVERABLE = 'UNDELIVERABLE';
export const DELIVERED = 'DELIVERED';
export const EXPIRED = 'EXPIRED';
export const REJECTED = 'REJECTED';
